export default {"src":"/_next/static/media/cactus.6e1cacd0.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};